export var OPEN_AUTH_MODAL = 'OPEN_AUTH_MODAL';
export var CLOSE_AUTH_MODAL = 'CLOSE_AUTH_MODAL';



// WEBPACK FOOTER //
// ./src/actions/auth/Login.js